import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { TranslateModule } from '@ngx-translate/core';
import { BaseModule } from '@seepex/ng-base';
import { TableVirtualScrollComponent } from './components/table-virtual-scroll/table-virtual-scroll.component';
import { TableComponent } from './components/table/table.component';
import { TableVirtualScrollDirective } from './directives/table-virtual-scroll.directive';

@NgModule({
  declarations: [TableVirtualScrollDirective, TableVirtualScrollComponent, TableComponent],
  exports: [TableVirtualScrollDirective, TableVirtualScrollComponent, TableComponent, MatTableModule, MatSortModule],
  imports: [CommonModule, BaseModule, ScrollingModule, MatTableModule, MatSortModule, TranslateModule.forChild()],
})
export class TableModule {}
